import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { productos } from "../data/productos";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const producto = productos[id];

  const [selectedSize, setSelectedSize] = useState("M");
  const [selectedColor, setSelectedColor] = useState("gris");

  const sizes = ["XS", "S", "M", "L", "XL"];
  const colors = [
    { name: "gris", color: "rgb(240, 240, 240)" },
    { name: "negro", color: "rgb(0, 0, 0)" },
    { name: "azul", color: "rgb(51, 102, 153)" },
  ];

  if (!producto) return <p className="p-10">Producto no encontrado</p>;

  const handleAddToCart = () => {
    // Aquí podrías guardar en contexto o localStorage si manejas carrito global
    navigate("/carrito");
  };

  return (
    <div className="relative flex flex-col min-h-screen bg-white font-sans">
      {/* Breadcrumb */}
      <div className="px-6 md:px-10 py-5 flex gap-2 text-sm md:text-base">
        <a href="#" className="text-gray-500">Mujeres</a>
        <span className="text-gray-500">/</span>
        <span className="text-gray-900 font-medium">{producto.nombre}</span>
      </div>

      {/* Contenido principal */}
      <div className="px-6 md:px-10 flex flex-col lg:flex-row gap-8 lg:gap-16">
        {/* Galería */}
        <div className="flex-1">
          <div className="w-full aspect-square bg-gray-100 rounded-lg overflow-hidden">
            <img
              src={producto.imagen}
              alt={producto.nombre}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="mt-3 flex gap-2">
            <div className="w-20 h-20 bg-gray-200 rounded-lg" />
            <div className="w-20 h-20 bg-gray-200 rounded-lg" />
            <div className="w-20 h-20 bg-gray-200 rounded-lg" />
          </div>
        </div>

        {/* Información */}
        <div className="flex-1 flex flex-col">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            {producto.nombre}
          </h1>
          <p className="text-gray-700 mb-2">{producto.descripcion}</p>
          <p className="text-lg font-semibold text-gray-900 mb-6">$79.99</p>

          {/* Tallas */}
          <h3 className="font-semibold text-gray-900 mb-2">Talla</h3>
          <div className="flex flex-wrap gap-3 mb-6">
            {sizes.map((size) => (
              <label
                key={size}
                className={`px-4 py-2 rounded-lg cursor-pointer text-sm font-medium transition ${
                  selectedSize === size
                    ? "border-2 border-gray-800 bg-gray-100"
                    : "border border-gray-300"
                }`}
              >
                {size}
                <input
                  type="radio"
                  className="hidden"
                  name="size"
                  value={size}
                  checked={selectedSize === size}
                  onChange={() => setSelectedSize(size)}
                />
              </label>
            ))}
          </div>

          {/* Colores */}
          <h3 className="font-semibold text-gray-900 mb-2">Color</h3>
          <div className="flex gap-3 mb-8">
            {colors.map((color) => (
              <label
                key={color.name}
                className={`w-10 h-10 rounded-full border cursor-pointer transition ${
                  selectedColor === color.name
                    ? "border-2 border-gray-800"
                    : "border border-gray-300"
                }`}
                style={{ backgroundColor: color.color }}
              >
                <input
                  type="radio"
                  className="hidden"
                  name="color"
                  value={color.name}
                  checked={selectedColor === color.name}
                  onChange={() => setSelectedColor(color.name)}
                />
              </label>
            ))}
          </div>

          {/* Botón */}
          <button
            onClick={handleAddToCart}
            className="bg-gray-900 hover:bg-gray-800 text-white py-3 px-6 rounded-lg font-bold w-full transition"
          >
            Agregar al Carrito
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
